'use strict';

var _foundationSites = require('foundation-sites');

var _foundationSites2 = _interopRequireDefault(_foundationSites);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('../sass/foundation.scss');

_foundationSites2.default.addToJquery($);

// import 'foundation-sites/js/foundation.core';
// import 'foundation-sites/js/foundation.util.keyboard';
// import 'foundation-sites/js/foundation.accordion';
// import 'foundation-sites/js/foundation.sticky';
// import 'foundation-sites/js/foundation.util.mediaQuery';
// import 'foundation-sites/js/foundation.offcanvas.js';
// import 'foundation-sites/js/foundation.responsiveMenu';
// import 'foundation-sites/js/foundation.util.triggers';
// import 'foundation-sites/js/foundation.util.box';
// import 'foundation-sites/js/foundation.util.nest';
// import 'foundation-sites/js/foundation.abide';
// import 'foundation-sites/js/foundation.util.motion';
// import 'foundation-sites/js/foundation.toggler';
// import 'foundation-sites/js/foundation.drilldown';

// Require
$(document).foundation();


//////////////////
// WEBPACK FOOTER
// ./client/layouts/mais.js
// module id = 346
// module chunks = 1